export default [
  {
    id: 501,
    title: 'Council Election',
    user: 'C010',
    day: 1862,
    message:
      "I want to talk about the Council's vote decisions and this new Council appointment. I can't believe they'd just… vote a newcomer onto the Council so easily. We don't know what their stance is. We don't know how they'll vote. All we can do is speak up and hope our voices are heard. I guess this is turning into more of an announcement now. Make sure you all speak up. Make sure the Council takes us into consideration when they vote!",
    comments: [],
    episode: 5,
  },
  {
    id: 502,
    title: 'The new Councilor??',
    user: 'D058',
    day: 1861,
    message:
      "C117? Seriously??? There are people who've been here for nearly as long as the Omega Protocol has been in place, and they pick the last person who happened to wander in from the surface? We don't know anything about this person, and they don't know anything about us. The Council has dropped more balls than a greased-up quarterback lately, but this one really takes the cake. Maybe Jordan has the right idea. I can't deal with this type of erratic leadership anymore.",
    comments: [
      {
        id: 1,
        user: 'D060',
        message:
          "Sounds like someone's just jealous. How many government conspiracies have you uncovered, Jacobs? A117 kept a madman from taking over. Now that madman has been replaced, and by a well deserving candidate in my opinion. Everything can finally go back to normal.",
      },
      {
        id: 2,
        user: 'D058',
        message:
          'You need to get your head out of the sand, Wanda. Who\'s to say the so-called "conspiracy" the Council is presenting to us even happened the way they say it did? Anyone who still trusts a single word that comes out of their mouths is an idiot.',
        replyDepth: 1,
      },
    ],
    episode: 5,
  },
  {
    id: 503,
    title: 'Exile',
    user: 'D054',
    day: 1861,
    message:
      "So Oswald is just gone? After all he did, we're just going to kick him out and be done?",
    comments: [
      {
        id: 1,
        user: 'C041',
        message: 'Not enough in my opinion, the Council should have gutted him like a fish.',
      },
      {
        id: 2,
        user: 'D033',
        message: "Isn't that a bit much?",
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'C041',
        message: 'He killed Persephone. Anything less than death for him is mercy.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D073',
        message: 'Kicking him out is basically a death sentence.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'C084',
        message:
          "The Council went too far. Why couldn't we have kept him locked up in here? Throwing him out of the facility is needlessly cruel.",
      },
      {
        id: 6,
        user: 'D109',
        message:
          "Sure, we'll just allocate a spare bedroom and the extra food we have to keeping a liar and murderer safe and sound.",
        replyDepth: 1,
      },
      {
        id: 7,
        user: 'D057',
        message:
          "Exactly. We barely have enough to go around as it is. We can't afford any dead weight.",
        replyDepth: 2,
      },
    ],
    episode: 5,
  },
  {
    id: 504,
    title: 'They can kick any of us out now',
    user: 'D031',
    day: 1860,
    message:
      'Exiling "Theo" is the beginning of the end. The Council has established their preferred form of punishment. If any of us step out of line, they\'ll throw us to the wolves. Or in this case, aliens.',
    comments: [
      {
        id: 1,
        user: 'D043',
        message:
          "Beginning? Wasn't the beginning of the end when an alien virus wiped out most of humanity?",
      },
      {
        id: 2,
        user: 'C044',
        message:
          "Bruno, you're being paranoid. This is an extreme situation and will likely never happen again.",
      },
      {
        id: 3,
        user: 'D094',
        message:
          "Yeah, just don't kill anyone, impersonate a federal agent for five years, or conspire to swing the results of a Council vote, and you'll be fine.",
        replyDepth: 1,
      },
      {
        id: 4,
        user: 'C020',
        message:
          "This is why we need the Lock-In to pass. If the doors are sealed, they can't do this to anyone else.",
      },
    ],
    episode: 5,
  },
  {
    id: 505,
    title: 'Is Jordan gone??',
    user: 'D049',
    day: 1860,
    message:
      "Did anyone else see the letter Jordan left in the rec room? This is crazy, I can't believe she'd abandon us like this. I'm trying to figure out who else left with her. So far it looks like Madeline, Phoenix, and a few members of the Elect are gone. Including the Sister.",
    comments: [
      {
        id: 1,
        user: 'D070',
        message: 'Hey, guys? Has anyone seen Jeremy????',
      },
      {
        id: 2,
        user: 'D071',
        message: 'Oh no. She didn’t.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D070',
        message: "I can't find him anywhere. I'm even checking the vents.",
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D071',
        message:
          "Has she gone insane? He won't survive an hour out there! This is kidnapping!!! We need to send someone out after them right now!!",
        replyDepth: 2,
      },
      {
        id: 5,
        user: 'D070',
        message:
          "Send who? It looks like all the scouts went with her. There's no way we're catching them. They're gone.",
        replyDepth: 2,
      },
      {
        id: 6,
        user: 'A001',
        message: 'Please deliver this letter to me so that the Council may assess the situation.',
      },
    ],
    episode: 5,
  },
  {
    id: 506,
    title: 'PATRICIA',
    user: 'D031',
    day: 1859,
    message:
      "Is anyone else having trouble with PATRICIA? Her responses are all garbled. Something's very, very wrong here. Do you think the Council created her as a way to control us? It was known even before the plague that A.I. could potentially evolve to be able to perform mind control. PATRICIA is going to kill us all or turn everything around and make us serve her like worker bees!",
    comments: [
      {
        id: 1,
        user: 'D018',
        message:
          "Chill, man. There's probably just a hiccup in the system, that's all. A001 and A002 are master programmers. They'll fix her, okay?",
      },
      {
        id: 2,
        user: 'D031',
        message:
          'I dunno, man. There have been plenty of lies and rumors and shady dealings going on right under our noses. Who knows what the Council is thinking. They could even be in on it. They could have programmed PATRICIA to do this all along. They lured us here to this facility and lulled us into a false sense of security!',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D018',
        message:
          "Oh, c'mon. The Council didn't \"lure\" us here. We struggled and survived outside until we stumbled across this place by accident… an extremely lucky accident. If it weren't for this facility and its Council, we'd all be dead. Just… relax, okay?  Maybe go see Dr. Cyril?",
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D031',
        message:
          "You'll see, Percy. You'll see. I'm not the kind of guy to wear a tinfoil hat, but I know a conspiracy when I see one. It's as plain as day!",
        replyDepth: 3,
      },
    ],
    episode: 5,
  },
  {
    id: 507,
    title: "Anto's reports",
    user: 'D053',
    day: 1859,
    message:
      'Can someone please explain to me what these reports mean? Is outside better or worse than being in here?',
    comments: [
      {
        id: 1,
        user: 'D062',
        message:
          'Define “better.” Would you rather have a few years, maybe even a few decades, of safety or hours to days of panic just so you can see the sky again?',
      },
      {
        id: 2,
        user: 'D111',
        message:
          "This blasphemy is a gross misinterpretation of the information Anto presented. His reports show that sealing the doors is entombing ourselves in this place. It is rejecting God's gift of the Earth for the small, sinful world created by man.",
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D093',
        message: "I think it means we're screwed either way.",
      },
      {
        id: 4,
        user: 'D085',
        message: "Yeah, but one of those ways doesn't involve getting eaten by aliens.",
        replyDepth: 1,
      },
      {
        id: 5,
        user: 'B016',
        message:
          "Anto's reports show us that it is a gamble either way. Staying here is a death sentence. That death might be five years away, or thirty, but we will die if we seal the doors. Leaving them open is a risk. It seems the world outside is changing in ways we don't understand, and potentially in ways that will be dangerous for us. But if we want to have any chance of the human race surviving beyond those of us in NACS, we have to leave the doors open. We have to believe that our story isn't over.",
      },
    ],
    episode: 5,
  },
  {
    id: 508,
    title: 'Hallelujah',
    user: 'D086',
    day: 1858,
    message:
      "Who else followed the message they got this morning and found the hidden part of the Intranet system? Science has confirmed what we've known in our hearts all along. Just like the Sister foretold, the Plague is gone. The Elect will inherit the Earth just as they've always been destined to.",
    comments: [
      {
        id: 1,
        user: 'B013',
        message: 'Amen.',
      },
      {
        id: 2,
        user: 'D080',
        message:
          "Sister, there are still aliens up there. I know Dr. Thomas' report is very encouraging, but please remember to be cautious. You shouldn't risk trying to make it in the wilderness up there, not with your age.",
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D082',
        message:
          "Especially because you won't be able to bring any food or medicine out with you. It's still a death sentence up there.",
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'B013',
        message:
          'We will be provided for by the Earth itself. The Angels will not harm us when they sense that our souls are Elect.',
        replyDepth: 3,
      },
    ],
    episode: 5,
  },
  {
    id: 509,
    title: 'We have no idea what day it is.',
    user: 'D028',
    day: 1858,
    message:
      "Is anyone else freaking out that we have no idea what day it is? I know the traitor is gone, but the damage is already done. We've been living with 30 hour days? How long has this been going on? How many days have we lost? We no longer have any connection to our own pasts because we can't say for sure when things even happened anymore!",
    comments: [
      {
        id: 1,
        user: 'D049',
        message:
          'Does it really matter? Once the Lock-In passes we\'re never going back to the surface again. Our records will be our own and who cares what arbitrary length of time a "day" is outside of our walls.',
      },
      {
        id: 2,
        user: 'D028',
        message:
          "Who cares? I do! If we don't even know how long a day is, how can we be sure anything is real?",
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D061',
        message: 'I prefer not to think about it. It makes my head hurt.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'C068',
        message:
          "The expedition team had a hunch something was up. Our logs of sunrise and sunset always seemed off. It didn't seem overly important at the time. Damn were we wrong.",
      },
      {
        id: 5,
        user: 'D091',
        message:
          "You knew and didn't say anything? What the hell is wrong with you all? I've always thought the expedition team were a bunch of elitist jerks. Thanks for proving me right.",
        replyDepth: 1,
      },
      {
        id: 6,
        user: 'D096',
        message:
          'They\'ve kept us alive. Seems like a pretty selfless gesture for a "bunch of elitist jerks."',
        replyDepth: 2,
      },
    ],
    episode: 5,
  },
  {
    id: 510,
    title: "There's no real choice.",
    user: 'D102',
    day: 1858,
    message:
      "We're letting all this nonsense about murder and Council members and viruses distract us from the one and only thing that we know for sure: it's dangerous up there. It's not perfect down here, but it's objectively safer. Some people here won't accept that. Some of them are people I care about very much, smart and kind people who just happen not to see reason. If they insist on leaving, I can't stop them. But I'll miss them very much.",
    comments: [
      {
        id: 1,
        user: 'D064',
        message:
          "I'll miss you too, Joanna. I hope you don't end up getting locked up down here. I hope that we'll see each other again someday down the line.",
        replyDepth: 1,
      },
      {
        id: 2,
        user: 'D102',
        message:
          "You know how I feel about that. The doors locking is the only way to make sure the aliens don't find their way down here. We need to wipe out the temptation to throw them open.",
        replyDepth: 2,
      },
    ],
    episode: 5,
  },
  {
    id: 401,
    title: 'Blood test',
    user: 'B012',
    day: 1857,
    message:
      'OFFICIAL COUNCIL ANNOUNCEMENT. <br>Following the release of new intel, it has come to everyone’s attention that we may be immune to the virus. I will be conducting blood tests for everyone’s CG content for all willing participants. Time is valuable, so please report to the med bay within the week to make your immunity screening appointment.',
    comments: [
      {
        id: 1,
        user: 'C053',
        message: 'If only Persephone were here to see this.',
      },
      {
        id: 2,
        user: 'D067',
        message:
          'Come on. None of that. We can’t keep dwelling on what could have been, or else we’ll all go crazy.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'C053',
        message: 'We all grieve in our own way',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D092',
        message: 'I’m curious, but I don’t know if I could go through with a blood test.',
      },
      {
        id: 5,
        user: 'D067',
        message:
          'Dude, you survived the freakin’ apocalypse… deadly virus and alien killing machines and all… and you’re still afraid of needles?',
        replyDepth: 1,
      },
      {
        id: 6,
        user: 'B017',
        message: 'Will there be lollipops like last time?',
      },
      {
        id: 7,
        user: 'B012',
        message: 'You only get one this time. We’re running low.',
        replyDepth: 1,
      },
    ],
    episode: 4,
  },
  {
    id: 402,
    title: 'Is P. A. T. R. I. C. I. A. okay?',
    user: 'D100',
    day: 1856,
    message:
      'A lot has been out of whack lately, and when I ask P. A. T. R. I. C. I. A. what’s wrong her responses are really odd. Is this scheduled maintenance or something?',
    comments: [
      {
        id: 1,
        user: 'C036',
        message:
          'I’ve been noticing things, too. Has the temperature in anyone else’s room been fluctuating? One moment I’m burning up and the next I’m freezing. I know a lot of people’s lights have been on the fritz as well.',
      },
      {
        id: 2,
        user: 'C014',
        message:
          'It’s the noises that get to me the most. I know it’s just random feedback from her speaker systems but I can’t help but feel like she’s screaming.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'C113',
        message: 'Has anyone tried turning her off and then turning her on again?',
        replyDepth: 1,
      },
    ],
    episode: 4,
  },
  {
    id: 403,
    title: 'Harvest season',
    user: 'B006',
    day: 1856,
    message:
      'Good day to everyone. Our produce is almost ready, so harvest season will be starting soon. <br><br>However, I’d like to note that this will not mean your rations will increase. The Council has made it clear that we still need to be careful in maintaining balance. I hope you all understand. <br><br>Thank you.',
    comments: [
      {
        id: 1,
        user: 'C010',
        message:
          'Are you alright, Anto? I haven’t seen you in so long and suddenly you pop up out of your botany lab with dark circles under your eyes.  Are you getting enough sleep?',
      },
      {
        id: 2,
        user: 'B006',
        message: 'I’m fine. Thank you, Faye.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D076',
        message:
          'Anto, you’ve let me, Jeff and Melanie into your lab to help less and less and it’s been worrying us. We want to help with whatever it is you’re dealing with.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'B006',
        message:
          'I said it’s fine, Ms. Marshall. I will contact you three when I need assistance, but as of right now, you’re to stay away from my lab.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'D021',
        message:
          'This is bullshit. We were told that ration tightening was only temporary. This is even more reason why we shouldn’t lock the doors.',
      },
      {
        id: 6,
        user: 'C036',
        message:
          'So your reasoning for keeping us exposed to death and destruction (not to mention complete and total extinction) is because you’re pissed you can’t get a few more carrots in your stew?',
        messageLine2: 'Get a grip on yourself.',
        replyDepth: 1,
      },
      {
        id: 7,
        user: 'D082',
        message: 'Whatever you say, boss.',
      },
    ],
    episode: 4,
  },
  {
    id: 404,
    title: 'A Proclamation',
    user: 'B013',
    day: 1855,
    message:
      'Members of the Elect, do you still doubt? Do you still cower in the shadows of uncertainty? Do you still deny your very natures?<br><br>We are not insects or dead things. We were meant to feel the sun on our faces. <br><br>Dwelling in this prison for so long has seeded evil in the hearts of those who swore to lead and protect us. We are ruled by murderers, liars, hypocrites, and their apologists. Those meant to preserve the remnants of human life have used their power to take life. We can no longer rely on them to make the correct moral choices in their leadership. In the darkness of this hollow Earth, they have lost sight of their mission. <br><br>We, the Elect, have not lost sight. If they continue to lead us further down into the pit of complacency, we will have no choice but to rise up against their false rulership. I say this not as a threat, but as a solemn vow. I will do all that I can to prevent our fate from being sealed. The doors of this ark will open, and we shall inherit the Earth at last.',
    comments: [
      {
        id: 1,
        user: 'A004',
        message:
          'Ada, please. You cannot undermine the democratic process like this. If the Council votes in favor of the Lock-In, all those who wish to leave will be allowed to do so. You won’t be a prisoner here. There is no need to issue ultimatums or threats.',
      },
      {
        id: 2,
        user: 'B013',
        message: 'What reason have you given any of us to believe you, Cyril?',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D031',
        message:
          'The sister has a point. I hope that she ends up being the one indicted onto the Council. Our current Councilors have lied to us so much that I honestly wouldn’t be surprised if the door’s already been locked for weeks.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D110',
        message:
          'Oh my God. You’re right. Are we already trapped? Does the air feel thinner to anyone else? I feel like the walls are closing in.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'B037',
        message: 'Calm down. Everything is okay. The door isn’t locked.',
        replyDepth: 4,
      },
      {
        id: 6,
        user: 'D031',
        message: 'And why should we believe you?',
        replyDepth: 5,
      },
      {
        id: 7,
        user: 'B037',
        message: 'Oh, come on Brinkman. What did I ever do to you?',
        replyDepth: 6,
      },
      {
        id: 8,
        user: 'D031',
        message:
          'With the way things are going, probably something horrible that I just haven’t found out about yet.',
        replyDepth: 7,
      },
    ],
    episode: 4,
  },
  {
    id: 405,
    title: 'Thank you Councilor Lind',
    user: 'D067',
    day: 1854,
    message:
      'I just wanted to say thank you to Councilor Lind for standing up to the rest of the Council and telling the rest of us what is really going on. I’m still not sure where I land on the Lock-In, but it’s nice to know at least one of our leaders wants us to know the truth.',
    comments: [
      {
        id: 1,
        user: 'D034',
        message:
          'What are you talking about? Mathias is the one causing all this infighting by advocating for sin. As stated in Genesis 1:26, God gave man dominion over all the earth. By turning our back on it we embrace the darkness.',
      },
      {
        id: 2,
        user: 'B013',
        message: 'Preach, my child!',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D009',
        message:
          'After all this insanity with Councilor Oswald it’s reassuring that Councilor Lind is still looking out for us.',
      },
      {
        id: 4,
        user: 'D067',
        message: 'Exactly.',
        replyDepth: 1,
      },
    ],
    episode: 4,
  },
  {
    id: 406,
    title: 'I will not die here',
    user: 'B022',
    day: 1854,
    message:
      'I don’t care how much bullshit Mathias spews, I’m not dying in this hole. You all can do what you want, but you will not seal me into this tomb.',
    comments: [
      {
        id: 1,
        user: 'C036',
        message: 'Don’t you think you’re overreacting? We’re all just trying to stay safe.',
      },
      {
        id: 2,
        user: 'B022',
        message:
          'Overreacting? Do you people even know what you’re suggesting by sealing the doors? This is insanity!',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'C020',
        message: 'If wanting to stay alive is insane, I’m happy to be crazy.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D047',
        message:
          'If you don’t like it, then leave. The rest of us will do what we have to for the good of everyone.',
      },
    ],
    episode: 4,
  },
  {
    id: 407,
    title: 'What’s the point of being against the Lock-In?',
    user: 'D065',
    day: 1853,
    message:
      'I could just reiterate the points of A003’s letter, but he’s already said it all. The anti Lock-In movement is being selfish and will get us all killed. They want us to be heroes and “retake earth. ” This isn’t some movie, this is reality. Going back outside means watching everyone you love die. It’s time to accept facts and focus on surviving.',
    comments: [
      {
        id: 1,
        user: 'B016',
        message: 'But we won’t survive locked in down here.',
      },
      {
        id: 2,
        user: 'D065',
        message:
          'We’ll last a hell of a lot longer down here than we will out there. You might be able to avoid the aliens, but do you think Jeremy can? How would you like to have his mutilated corpse on your conscious?',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'B037',
        message:
          'Leave Jeremy out of this or it won’t be his mutilated corpse you need to worry about.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D050',
        message:
          'Save the badass act, Jordan. You and your team are delusional if you think any of the rest of us have a chance out there.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'B037',
        message: 'Call my team delusional again and I’ll show you how much of an “act” it is.',
        replyDepth: 4,
      },
    ],
    episode: 4,
  },
  {
    id: 408,
    title: 'What is happening to us?',
    user: 'D058',
    day: 1852,
    message:
      'Have we all lost our minds? One of our leaders killed a member of this community, the others are all pushing their own agendas, and we’re all wasting our time fighting amongst ourselves? We need to be fighting them. We have to show them we aren’t going to be manipulated like this. We need to set aside our petty differences and present a united front against this tyranny!',
    comments: [
      {
        id: 1,
        user: 'D083',
        message: 'That’s all well and good, but we still need a decision about the door, right?',
      },
      {
        id: 2,
        user: 'D058',
        message: 'The door doesn’t matter. It’s just a tool they’re using to control us.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D116',
        message:
          'Doesn’t matter? How many family members have you lost? How long have you been safe and secure in here? It’s a hellscape outside. I watched one loved one after another die and I will not watch that happen again. We need to lock the doors.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'B038',
        message:
          'So you’d rather watch all of us die in here because we can’t get the supplies we need?',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'D116',
        message:
          'I’d rather as many of us live for as long as we can. In here we’d have years. Out there we’d have days. Easy call to make.',
        replyDepth: 4,
      },
    ],
    episode: 4,
  },
  {
    id: 409,
    title: 'Outside',
    user: 'D048',
    day: 1851,
    message:
      'Is what Mathias said true? Why won’t plants grow outside anymore? Will that affect our food supply here? We deserve to know what’s happening to our planet.',
    comments: [
      {
        id: 1,
        user: 'A001',
        message:
          'Unfortunately we don’t have any answers for you, which is why most of the Council wanted to stay quiet about this. What I can say is B006 and B012 are looking into it. As soon as they have any information we will pass it along to you. We will not be taking further comments at this time.',
      },
    ],
    episode: 4,
  },
  {
    id: 410,
    title: 'We need to get out of here.',
    user: 'D027',
    day: 1851,
    message:
      'Imagine if the Lock-In had been initiated before we realized what Councilor Oswald had done. We’d all be stuck down here with a murderer and no way out. I used to be pretty staunchly in favor of the Lock-In, but this is giving me some serious second thoughts. Hell, maybe the exact same kind of trouble will happen with whoever ends up replacing Oswald. We can’t have a system in place that locks us in with the people who control us. We need to have a way to escape if things go really wrong.',
    comments: [
      {
        id: 1,
        user: 'D085',
        message:
          'Oh, please! One murderous human is nothing compared to the monsters on the surface. Oswald is safely in custody right now. Get an extraterrestrial in custody without sacrificing upwards of ten people and then we’ll talk.',
      },
      {
        id: 2,
        user: 'D062',
        message:
          'Plus, people are conveniently forgetting that Oswald’s only crime was pushing a button. The aliens were the ones that actually did those horrific things to B005.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D040',
        message:
          'Councilor Oswald knew we had forgotten the dangers of the surface after spending years down here safe and sound. He risked exile to remind us why we can’t go back up there. He’s a hero.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D058',
        message:
          'Hero? Are you serious? He’s a murderer! The aliens are terrifying, but they’re creatures of instinct. He knew what he did was wrong. That makes him the real monster in my book.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'D065',
        message:
          'He sacrificed one person for the good of the many. That’s the exact kind of difficult call that leaders are supposed to make. Hopefully his successor is able to do the same.',
        replyDepth: 4,
      },
    ],
    episode: 4,
  },
  {
    id: 411,
    title: 'Additional Announcement',
    user: 'A003',
    day: 1851,
    message:
      'There is one additional piece of information Councilor Farrahmand left off of his announcement list. In the interest of full disclosure, and in light of the upcoming Lock-In vote, I believe you all need this information. The Council has recently received a confidential report about the state of the outside world. The soil outside of the facility is becoming inhospitable for plant life. In the very near future it will be impossible for plants to grow in the surrounding area. If we can grow crops better internally, why are we risking leaving the doors open? The outside world holds nothing but death for us. It is time we stop pretending otherwise.',
    comments: [
      {
        id: 1,
        user: 'A004',
        message:
          'I did not leave anything off of my list, Councilor Lind. The Council has already discussed this matter and decided on a course of action. I am locking the comments.',
      },
    ],
    episode: 4,
  },
  {
    id: 412,
    title: 'Several Important Announcements',
    user: 'A004',
    day: 1851,
    message:
      'I urge residents of the NACS facility to remain calm in light of the following information. <br><br>It has been revealed that the death of Persephone Grace was not a result of the virus as we initially reported in order to avoid a panic. Nor was it the result of random extraterrestrial violence on the outskirts of the base as we initially thought. <br><br>Persephone Grace was murdered by resident A007, Shepard Oswald. <br><br>Mr. Oswald appears to have allowed Ms. Grace to leave the facility. Once she was outside, Mr. Oswald attracted a swarm of extraterrestrials to her through improper usage of a standard- issue ULF Emitter. <br><br>This information came to light as a result of an internal investigation spearheaded by Councilor Woods. <br><br>Mr. Oswald has been apprehended and is currently being held in the Council Quarters. He has been found unfit to govern and has been expelled from his position on the Council. His ultimate fate has yet to be decided. <br><br>Despite assertions by some fellow Councilors to the contrary, I do not believe we have sufficient evidence to conclusively condemn Mr. Oswald for P. A. T. R. I. C. I. A. ’s recent malfunctions. By the admission of my two esteemed colleagues, there is nothing in Mr. Oswald’s personal or professional background that would explain a sudden aptitude for high-level technological sabotage. <br><br>The vote on the Lock-In Protocol will proceed as planned. The consensus of three Council members will be needed to pass the resolution one way or another. <br><br>To avoid a tie, a resident of the base will be appointed to the Council in the near future. The nominee for this position will need the approval of at least three of the four current Council members to be officially confirmed. <br><br>A001 has already proposed a candidate for this position. Her motion has been seconded by A002. I will review this candidate myself in the coming days. If I find them to be a capable individual with the facility’s best interests at heart, I will provide the third and final vote needed to induct this person to the Council. <br><br>Any questions, comments, or concerns regarding this announcement can be delivered to my office in written form.',
    comments: [],
    episode: 4,
  },
  {
    id: 301,
    title: 'Who wants to switch roommates?',
    user: 'B016',
    day: 1850,
    message:
      'Someone thought it was a cute idea to lock me out of our bedroom after a disagreement we had about the vote.',
    comments: [],
    episode: 3,
  },
  {
    id: 302,
    title: 'A note about appointments',
    user: 'A004',
    day: 1849,
    message:
      'Hello, all. In the past few weeks I’ve seen quite an uptick in requests for appointments. This is a very understandable development given the many recent occurrences in the facility. Unfortunately, due to the increased demand for my time I cannot continue to offer hour-long sessions for the foreseeable future. Going forward, sessions will last for a maximum of thirty minutes. I will reverse this policy as soon as the overall level of stress has lowered amongst residents and demand for my time has settled down. I would also like to add that one-on-one appointments with me are not an appropriate venue to lobby or petition me regarding the upcoming vote. I work very hard to keep my roles as Council member and mental health professional separate in order to avoid creating conflicts of interest as best I can. I will, of course, listen to your feelings surrounding the decision as long as they pertain to your personal mental health. But I will not answer any questions regarding my own or my fellow Council members’ private deliberations. Nor will I entertain blatant attempts to sway me one way or another. Another note: Please remember that group therapy is supposed to be a space for all residents to express themselves. Anyone who instigates what I judge to be uncivil conversation will be asked to leave. Any and all personal insults or name calling will result in a temporary ban from attending group therapy sessions.',
    comments: [
      {
        id: 1,
        user: 'C062',
        message:
          'The final note is too little too late, Doctor. I’m just not interested in showing up to group therapy anymore, not after certain people have made it less about sharing our feelings and more about pushing their political agenda.',
      },
      {
        id: 2,
        user: 'D059',
        message:
          'What exactly are we supposed to talk about in group? The weather?  Some of us happen to have feelings about the most pressing issues facing the base.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'C011',
        message:
          'I’d like to be able to speak frankly about the experience of seeing my family torn apart by monsters in front of me, without being told that I should just get over it. Those leaked pictures of Persephone brought so much back for me that I thought I’d managed to repress. I’ve been having even more nightmares than usual ever since, and now I have no place to talk about them. I’m tired of being told to get over my trauma and head into certain death by the people who were lucky enough to not have seen just how gruesome it can get up there firsthand.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D092',
        message:
          'Thank you for the heads up, Doctor. We know how hard you’re working and we all appreciate the effort. I, for one, know that you’ll end up casting your vote for the best option.',
      },
      {
        id: 5,
        user: 'D083',
        message:
          'Wow Lucille, can you get more blatant? Stop sucking up to the Councilor. You’re not going to flatter him into burying all of us alive.',
        replyDepth: 1,
      },
      {
        id: 6,
        user: 'D035',
        message:
          'I have to admit I don’t love this policy. I’ve been having more flashbacks about my time on the surface and I’ve really been needing someone to talk to. But I understand that that’s the case for a lot of us. See you tomorrow, Dr. Farrahmand.',
      },
    ],
    episode: 3,
  },
  {
    id: 303,
    title: 'Has anyone seen my bag?',
    user: 'B017',
    day: 1849,
    message:
      'So, this is kind of embarrassing, but has anyone seen my bag? I can’t find it and I know there are important messages in there I was supposed to deliver. Or at least I think they were important, I couldn’t understand what they said.',
    comments: [
      {
        id: 1,
        user: 'B022',
        message: 'Jeremy, are you reading people’s private messages again?',
      },
      {
        id: 2,
        user: 'B017',
        message: 'I can’t because I don’t know where my bag is.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D033',
        message: 'Well where was the last place you saw it?',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'B017',
        message:
          'I don’t remember. It was either in the cantina, or the dormitories, or the botany lab, or the vents.',
        replyDepth: 4,
      },
      {
        id: 5,
        user: 'D033',
        message: 'Have you checked all of those places?',
        replyDepth: 5,
      },
      {
        id: 6,
        user: 'B017',
        message: 'No, that’s a lot of places. I was hoping someone else would find it.',
        replyDepth: 6,
      },
      {
        id: 7,
        user: 'D054',
        message: 'Didn’t Jordan just get you a new bag?',
        replyDepth: 2,
      },
      {
        id: 8,
        user: 'B017',
        message: 'Yeah, and I don’t want her to find out I lost it already.',
        replyDepth: 3,
      },
      {
        id: 9,
        user: 'D050',
        message: 'Then maybe don’t talk about it on the public discourse.',
        replyDepth: 4,
      },
      {
        id: 10,
        user: 'B017',
        message: 'Then how am I supposed to get everyone to help me find it?',
        replyDepth: 5,
      },
      {
        id: 11,
        user: 'B037',
        message:
          'Watch yourself, George. I know where you sleep. It’s okay Jeremy. I’ll help you find it later and we can talk about how to better take care of your things.',
        replyDepth: 6,
      },
      {
        id: 12,
        user: 'B017',
        message: 'Thanks Jordan!',
        replyDepth: 7,
      },
    ],
    episode: 3,
  },
  {
    id: 304,
    title: 'Underwent a transcendental experience today',
    user: 'D034',
    day: 1848,
    message:
      'I think today’s sermon had the highest turn-out I’ve ever seen! For a regular event and not a memorial, at least. And what a sermon it was. I thought the Sister was going to start speaking in tongues. It’s amazing just to be in her presence. You can tell just from listening to her how enlightened she is.',
    comments: [
      {
        id: 1,
        user: 'D086',
        message:
          'I really do think the Plague will die out one day soon, if it hasn’t already. I can’t imagine the Plague would even be able to kill a true member of the Elect in the first place, despite what we’ve been told. The Angels could usher us into a new age of prosperity if we made contact with them.',
      },
    ],
    episode: 3,
  },
  {
    id: 305,
    title: 'If you don’t want to lock the doors you might as well leave the base',
    user: 'D062',
    day: 1848,
    message:
      'Seriously. I just think it’s funny how nobody fighting the Lock-In would actually have the guts to go outside without a hazmat suit. Prove me wrong.',
    comments: [
      {
        id: 1,
        user: 'C036',
        message: 'Haha, so true. None of them would ever put their money where their mouths are.',
      },
      {
        id: 2,
        user: 'B046',
        message:
          'You’re conveniently forgetting that every single active scout (you know, the people with the most knowledge and expertise about the surface) is against the Lock-In.',
      },
      {
        id: 3,
        user: 'D042',
        message:
          'I hope you realize the only reason you haven’t been infected or torn to shreds by monsters is that you’ve had this base to come running back to. You scouts just want to feel special. You need to accept that soon we’ll be self-sustaining and nobody will need you anymore.',
        replyDepth: 1,
      },
    ],
    episode: 3,
  },
  {
    id: 306,
    title: 'Three notches back for two up front',
    user: 'C041',
    day: 1847,
    message: 'Two upfront rtns, will owe three in interest. I’ll be hungry, but it’ll be worth it.',
    comments: [
      {
        id: 1,
        user: 'C053',
        message: 'Accepted. On its way.',
      },
      {
        id: 2,
        user: 'D009',
        message: 'What about a rare cluster piece?',
      },
      {
        id: 3,
        user: 'C041',
        message: 'Dude, I don’t have that many rtns.',
        replyDepth: 1,
      },
      {
        id: 4,
        user: 'D056',
        message:
          'Look at Jeremy’s noodle packet. He keeps track of exchanges. You might be able to track down someone who has one.',
        replyDepth: 2,
      },
      {
        id: 5,
        user: 'C011',
        message: 'He really freakin’ loves that thing, huh.',
        replyDepth: 3,
      },
      {
        id: 6,
        user: 'B006',
        message: 'It’s his favorite snack.',
        replyDepth: 4,
      },
      {
        id: 7,
        user: 'C081',
        message:
          'He just… ate it so quickly. That flavor is so much more valuable now, and he just ate it away!',
        replyDepth: 5,
      },
      {
        id: 8,
        user: 'B006',
        message:
          'He keeps the wrapper for nostalgia. And keeping track of ration rates. Yes, I know about those. You’re lucky I like Jeremy so much.',
        replyDepth: 6,
      },
    ],
    episode: 3,
  },
  {
    id: 307,
    title: 'Enough is enough',
    user: 'D089',
    day: 1846,
    message:
      'What are we still doing discussing whether or not to leave the doors open? We now know exactly what is waiting for us out there. Nothing but disease, aliens, and death. We need to close the doors. Now.',
    comments: [
      {
        id: 1,
        user: 'C068',
        message: 'I think you’re overreacting a bit.',
      },
      {
        id: 2,
        user: 'D089',
        message:
          'Overreacting? How can you say that? We have proof written by Persephone herself about how terrible it is out there.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'C068',
        message:
          'I don’t want to downplay whatever Persephone went through, but I’ve been outside of these walls dozens of times, and so has everyone else on the expedition team. I’m not saying it isn’t dangerous, but with the proper precautions it is manageable.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D062',
        message:
          'Maybe for the scouts. But what about the rest of us? We need to think about the safety of the entire community.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'B037',
        message:
          'How safe will you all be from starvation and medical emergencies once those doors are closed?',
        replyDepth: 4,
      },
    ],
    episode: 3,
  },
  {
    id: 308,
    title: 'Be wary of J.',
    user: 'D077',
    day: 1846,
    message:
      'B017’s been acting real antsy lately. I’ve seen this before. The boy’s cracking. We all will eventually. I’m just surprised he didn’t break down sooner.  Be careful around him. I’m not sure what he’s capable of.',
    comments: [
      {
        id: 1,
        user: 'C020',
        message: 'Right? Have you seen the way he dodges those security cameras?',
      },
      {
        id: 2,
        user: 'B017',
        message: 'I just wait for them to move.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'A002',
        message:
          'He is still only small boy. If you spread nonsense again, I will not tolerate it.',
      },
      {
        id: 4,
        user: 'D064',
        message:
          'C’mon, it’s not that bad. Jeremy’s just under a lot of pressure. Sure, he’s been a bit more jittery than usual but who wouldn’t be right now?  I shake every time I think about the doors closing in on us for good.',
      },
      {
        id: 5,
        user: 'D062',
        message:
          'Well, I shake with fear when I think of those monsters outside getting in!  I’ve seen them! I’ve seen what they can do! You’re a weak bleeding heart if you think that our problems will suddenly go away without us needing to take these necessary precautions! And what about Jeremy?  If he loses it then we’d have to worry about a monster INSIDE as well. He’s the courier—he can move about the facility freely. Hell! He’s even used some of the ducts for travel!  I wouldn’t be surprised if he started killing us one by one in our sleep… like some kind of horror movie!',
        replyDepth: 1,
      },
      {
        id: 6,
        user: 'D064',
        message: 'Did you have a point?',
        replyDepth: 2,
      },
      {
        id: 7,
        user: 'D062',
        message:
          'Shove it, Ivan. If the doors stay open, I hope you’re the first to go so I can laugh at you about how wrong you always were.',
        replyDepth: 3,
      },
      {
        id: 8,
        user: 'D077',
        message:
          'Please, let’s not fight. I was only suggesting that we keep a close eye on B017. Maybe send him to Dr. Cyril. Just as a precaution.',
        replyDepth: 4,
      },
      {
        id: 9,
        user: 'D073',
        message:
          'D062 over here wants to take charge, eh!  Why don’t you just go running to Mathias like you always do?  Tell the Council you’re in charge and you’re here to shut the doors with no vote, and destroy whatever remnants of democracy we have left. Go on. I’m sure that’ll go over well with them!',
        replyDepth: 4,
      },
      {
        id: 10,
        user: 'D062',
        message: 'I don’t debate with people who debase themselves by yelling.',
        replyDepth: 5,
      },
      {
        id: 11,
        user: 'A004',
        message:
          'I’ll talk to Jeremy, everyone. It’ll be fine.  We all get anxious from time to time, and for all of us it’s most of the time. I’ll talk with him and see what’s wrong, but I assure you all, it’s nothing to be worried about.',
      },
    ],
    episode: 3,
  },
  {
    id: 309,
    title: 'A nice, quiet night',
    user: 'C084',
    day: 1845,
    message:
      'Does anyone want to meet up tonight and not talk about any of this? I’m so sick of the arguing and I just want a nice quiet night where we can forget about everything going on for a few hours.',
    comments: [
      {
        id: 1,
        user: 'D061',
        message: 'That sounds great',
      },
      {
        id: 2,
        user: 'C053',
        message: 'Count me in too. Maybe we can get in a few rounds of cluster?',
      },
      {
        id: 3,
        user: 'C084',
        message: 'First to lose is a cluster buster!',
        replyDepth: 1,
      },
      {
        id: 4,
        user: 'D023',
        message:
          'Burying your heads in the sand won’t fix anything. We need to figure this out before it’s too late and we’re trapped in here forever.',
      },
      {
        id: 5,
        user: 'C041',
        message:
          'For the love of god, Cameron, can you please take a night off? You’re exhausting.',
        replyDepth: 1,
      },
    ],
    episode: 3,
  },
  {
    id: 310,
    title: 'Anybody else’s watch not working?',
    user: 'D061',
    day: 1845,
    message:
      'I swear, I need to wind and re-wind every single kind of watch there is in this place. The NACS issued ones, the ones the scouts manage to get their hands on, all of them. Even with new batteries. I know it doesn’t really matter in the grand scheme, but it’s still a real pain.',
    comments: [
      {
        id: 1,
        user: 'B046',
        message:
          'My most sincere apologies. The next time we’re scavenging the wasteland for necessary supplies we’ll be sure to find you a suitably high-caliber timepiece. Would a Swedish make be preferable to monsieur?',
      },
      {
        id: 2,
        user: 'D061',
        message: "Oh, come on Sal. I didn't mean it like that. ",
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'B037',
        message:
          'We’re doing our best out there, that’s all I can say. P.A.T.R.I.C.I.A. takes care of all the timekeeping anyway.',
        replyDepth: 2,
      },
    ],
    episode: 3,
  },
  {
    id: 311,
    title: 'LOCK THE DOORS',
    user: 'D047',
    day: 1844,
    message: 'LOCK THE DOORS! LOCK THE DOORS! LOCK THE DOORS!',
    comments: [
      {
        id: 1,
        user: 'C020',
        message:
          'Add something productive to the conversation or I’m filing a report to have your discourse privileges revoked.',
      },
      {
        id: 2,
        user: 'D047',
        message:
          'First of all, you don’t have the authority to do that. Second of all, look at the other posts. Is mine really the worst thing on here? I’m just saying what everyone knows we have to do.',
        replyDepth: 1,
      },
    ],
    episode: 3,
  },
  {
    id: 312,
    title: 'Unapproved Document Distribution',
    user: 'A001',
    day: 1843,
    message:
      'It has come to the Council’s attention that there is a document being distributed throughout the facility containing what appears to be notes from Persephone Grace’s handbook. This information was not reviewed by the Council before being distributed, and in no way reflects the Council’s overall position on the Lock-In. If you are in the possession of one of these documents we ask that you turn it in to the Council at once so we can remove it from circulation. Thank you for your cooperation.',
    comments: [],
    episode: 3,
  },
  {
    id: 313,
    title: 'What is this garbage?',
    user: 'D021',
    day: 1843,
    message:
      'Have you all seen this flyer going around? What the hell is the Council trying to do in publishing this crap? Persephone’s gone and now they’re trying to use her death to push their own agenda? How do we know this is even her actual handwriting? Where is the proof? If you ask me they’re doing anything they can to hold onto their little seat of power. They had better watch themselves or they’re going to be facing a very large, very angry crowd.',
    comments: [
      {
        id: 1,
        user: 'C011',
        message:
          'Add something productive to the conversation or I’m filing a report to have your discourse privileges revoked. I for one am happy they are willing to tell us the truth, no matter how ugly it is.',
      },
      {
        id: 2,
        user: 'D021',
        message:
          'And I for one am not willing to believe something just because some power-hungry cabal tells me to.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D105',
        message: 'I think you’re reading too much into this.',
      },
      {
        id: 4,
        user: 'A007',
        message: 'Are you making a threat against the Council?',
      },
      {
        id: 5,
        user: 'D021',
        message: 'Read it however you want. Just know we’re watching you.',
        replyDepth: 1,
      },
      {
        id: 6,
        user: 'A007',
        message:
          'I will not have you inciting violence in this facility. Report to the Council Chamber immediately.',
        replyDepth: 2,
      },
    ],
    episode: 3,
  },
  {
    id: 201,
    title: 'Group Discussion',
    user: 'A004',
    day: 1841,
    message:
      'Hello everyone, It has come to the Council’s attention that there is a lot of anxiety about these recent revelations. I know a lot of you have questions about why the Council mislead the community about the details surrounding Persephone’s death. Rather than continue to allow these discussions to run rampant in the hallways or here on the Discourse, I think we should all gather together and talk through it. Several members of the Council will be in the cantina at 1800 tonight to listen to all of your concerns and hopefully provide answers that will put your minds at ease. I am locking comments to this post in hopes that it will encourage those of you with opinions on this matter to show up and join the conversation tonight.',
    comments: [],
    episode: 2,
  },
  {
    id: 202,
    title: 'Aliens!',
    user: 'D085',
    day: 1841,
    message:
      'They’re going to kill us all. Persephone was just the start. This is how it all ends. We need to lock the doors. We need to give everyone weapons. We have to act now before it’s too late!',
    comments: [
      {
        id: 1,
        user: 'D050',
        message: 'Damn dude, take it easy.',
      },
      {
        id: 2,
        user: 'D085',
        message: 'How am I supposed to take it easy? We’re all going to die!',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D050',
        message: 'Well we’re all going to die at some point right? So why worry about it?',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'C032',
        message:
          'George, you’re not helping. Benny, I could use a hand for dinner prep, want to help me out? It might take your mind off things.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'A004',
        message:
          'Benny, why don’t you stop by and see me? I’d love to talk with you for a bit about all of this.',
      },
    ],
    episode: 2,
  },
  {
    id: 203,
    title: 'We should lock the doors',
    user: 'C063',
    day: 1840,
    message:
      'In light of recent events, we should really consider locking the doors now. 1 - if the aliens know where we are it’s the safest thing to do and 2 - we’re growing more and more of our food. Why are we still risking the virus or the aliens making their way into NACS by leaving the doors open?',
    comments: [
      {
        id: 1,
        user: 'D047',
        message: 'Right there with you.',
      },
      {
        id: 2,
        user: 'D090',
        message: 'Me too.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D080',
        message: 'Isn’t that being a bit hasty?',
      },
      {
        id: 4,
        user: 'D061',
        message:
          'Are we sure we’re growing enough food? I don’t want to starve to death just because we all got a little spooked.',
      },
    ],
    episode: 2,
  },
  {
    id: 204,
    title: 'New Cluster Variant',
    user: 'D072',
    day: 1839,
    message:
      'I know there’s a lot going on, so I doubt I’m the only one who needs a distraction. I’ve been putting together a new cluster variant to incorporate the backgammon pieces Todd “found” in his bunk. Anyone looking for a game?',
    comments: [
      {
        id: 1,
        user: 'D087',
        message:
          'I don’t know what you’re insinuating with those quotes, but I’d love to play. Especially since you’re using “my” pieces.',
      },
      {
        id: 2,
        user: 'D072',
        message: 'I don’t think you know how quotes work.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D090',
        message: 'Careful Sam. He cheats!',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D087',
        message: 'Shut up Kenny!',
        replyDepth: 3,
      },
    ],
    episode: 2,
  },
  {
    id: 205,
    title: 'The Council did nothing wrong',
    user: 'D110',
    day: 1837,
    message:
      'The Council was right to hide the horrific nature of Persephone’s death from us. How have any of our lives been improved by knowing it was an alien attack? All it has done is make people panic and worry over something we can’t control. No one likes to be lied to, but it was in the best interest of the community to keep everyone calm until a plan of action could be formed.',
    comments: [
      {
        id: 1,
        user: 'D059',
        message:
          'I still think they should have told us. The panic is because we found out they lied.',
      },
      {
        id: 2,
        user: 'D094',
        message: 'I panicked because of the aliens, but to each their own.',
        replyDepth: 1,
      },
    ],
    episode: 2,
  },
  {
    id: 206,
    title: 'They lied to us!',
    user: 'D021',
    day: 1837,
    message:
      'What the hell? The Council lied to us! They told us she died because of the virus. A virus doesn’t do that to a person! If the aliens are at our door we deserve to know.',
    comments: [
      {
        id: 1,
        user: 'C025',
        message: 'Well you can’t really blame them.',
      },
      {
        id: 2,
        user: 'D021',
        message: 'What do you mean? Of course we can blame them!',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'C025',
        message:
          'They probably didn’t want to cause a panic. I think they made the right call. The bigger issue is, who leaked the picture to the rest of us?',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D021',
        message: 'A hero. Someone who actually cares about us.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'D057',
        message:
          'I don’t know why they would do this. If we can’t trust the Council, who can we trust?',
      },
      {
        id: 6,
        user: 'D021',
        message: 'No one.',
        replyDepth: 1,
      },
    ],
    episode: 2,
  },
  {
    id: 207,
    title: 'Tighter food rations',
    user: 'A003',
    day: 1835,
    message:
      'Attention all residents. Due to an unfortunate combination of events, our botany lab will be growing less food over the next two weeks. This is no cause for alarm, as our resident botanist has already corrected the issue. That being said, food rationing will be tighter until production returns to normal levels.',
    comments: [
      {
        id: 1,
        user: 'D055',
        message: 'That’s discouraging to hear. Will this be a regular thing?',
      },
      {
        id: 2,
        user: 'B006',
        message:
          'Absolutely not. Just a series of mishaps. I apologize for the inconvenience and thank you for your understanding.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D021',
        message:
          'At least we have non-perishables to hold us over. What would we do if the lock-in occurs and this happens again?',
      },
      {
        id: 4,
        user: 'A003',
        message:
          'That is extremely unlikely, but the Council has contingency plans in the event of such an occurrence.',
        replyDepth: 1,
      },
    ],
    episode: 2,
  },
  {
    id: 208,
    title: 'Jeremy',
    user: 'C020',
    day: 1834,
    message:
      'Warning to anyone using Jeremy as your messenger:   I know we all want our privacy and that’s why we keep certain things off the system and away from P.A.T.R.I.C.I.A. But I’ve caught Jeremy several times going through my mail. Remember: ALWAYS ENCRYPT YOUR MESSAGES.',
    comments: [
      {
        id: 1,
        user: 'D112',
        message:
          'I had to tell him why going through another person’s mail was a big no-no.  Kids have to be treated like kids.',
      },
      {
        id: 2,
        user: 'D088',
        message: 'He’s not a child.  He’s just been sheltered all his life. He’s harmless.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D112',
        message: 'Not so sure about “harmless. ”',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D088',
        message: 'You’re never sure about anything.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'D066',
        message:
          'I feel bad for Jeremy.  He’s a really good kid and everyone pushes him around just because they can.  He just seems really lost all the time. It makes me want to take care of him.',
      },
      {
        id: 6,
        user: 'D050',
        message: 'Gross',
        replyDepth: 1,
      },
      {
        id: 7,
        user: 'D102',
        message:
          'I guess no one really took the time to teach him anything. Except for maybe Jordan. Or Alosha. But it isn’t good enough. Jeremy needs discipline.',
        replyDepth: 1,
      },
      {
        id: 8,
        user: 'D056',
        message:
          'Randall used to play chess with Jeremy. I’ve seen him pick that up. Jeremy still looks for people to play with now that Randall’s passed. Poor Randall… I don’t think he was ready to go.',
        replyDepth: 2,
      },
      {
        id: 9,
        user: 'C032',
        message:
          'Don’t feel bad for Randall. Lucky bastard got to live to the ripe ol’ age of 96. How many of us will be able to do the same?',
        replyDepth: 3,
      },
      {
        id: 10,
        user: 'D078',
        message:
          'I asked Jeremy once why he opened my mail.  He said he thought it was for him. The kid looked so sincere… I couldn’t tell if he was taking the piss or not.',
      },
      {
        id: 11,
        user: 'D099',
        message:
          'If you’re upfront with him before giving him anything, he’ll actually listen. Just don’t use any metaphors. It confuses him.',
      },
      {
        id: 12,
        user: 'B037',
        message:
          'I honestly think the kid means well.  Like User D088  said, he was sheltered all his life. Considering what I’ve heard from him about his parents, I’m really not all that surprised.  He’s not dumb. Have you seen the way he plays chess?  I might be more worried that he’s been flying under the radar and he’ll end up outwitting us all. @B017 Jeremy, your old bag was falling apart so I left you a new one on your cot.',
      },
      {
        id: 13,
        user: 'B017',
        message:
          'Wow!  I love it!  It’s not dirty at all, no rips in it or anything!  Thanks, Jordan!',
        replyDepth: 1,
      },
      {
        id: 14,
        user: 'B037',
        message: 'You’re welcome, sweetheart.',
        replyDepth: 2,
      },
    ],
    episode: 2,
  },
  {
    id: 209,
    title: 'This vote seems ludicrous',
    user: 'D064',
    day: 1830,
    message:
      'A certain courier has really been hounding me lately to give my opinion on the whole Lock-In Protocol the Council is supposedly looking into. The more I think about it now, the more confused I get. We have a big, strong, heavy door that we can open and close at will. What would we possibly stand to gain from cutting off the option to go out into the world? ',
    comments: [
      {
        id: 1,
        user: 'C063',
        message:
          'It’s not about what we stand to gain but what we stand to lose. All it would potentially take for every single one of us to be wiped out would be for an animal our scouts hunt to be carrying a mutated form of the virus. The risk of putting our scouts out into the world once every month far outweighs the benefits of trying to split a trickle of scrap metal, candy bars, and ibuprofen among 100 people. We have decades of supplies stored down here. Dr. Whelan has gotten us to a point where we’re basically self-sustaining, and the water system can harvest all the moisture in the soil for miles around.',
      },
      {
        id: 2,
        user: 'A003',
        message: 'Bravo. Couldn’t have said it better myself.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D080',
        message:
          'But what if there are still other people out there? Are you saying we should have just turned C117 away?',
        replyDepth: 1,
      },
      {
        id: 4,
        user: 'C063',
        message:
          'No offense to C117, but yes. Every new person we take in is at an increased risk of being either a carrier of a mutated form of the virus or completely psychotic from having spent so much time alone on the surface. Plus, we’re at capacity. We have all the skilled and unskilled labor we need. Anyone else would just be a drain on our resources.',
        replyDepth: 2,
      },
      {
        id: 5,
        user: 'C081',
        message:
          'I know that it’s been the policy to just throw our doors open for anyone who wanders by, but it certainly couldn’t hurt us to be more careful about who we take in.',
        replyDepth: 2,
      },
      {
        id: 6,
        user: 'B037',
        message:
          'Do you hear yourself? It sure could hurt the actual people we’d be turning away.  ',
        replyDepth: 3,
      },
      {
        id: 7,
        user: 'C025',
        message:
          'I’m not advocating for one side or the other, but you do make some good points Augustus, especially about expeditions. Are the things Jordan and her squad bring back useful? Yes. Do I like getting them? Sure. But we’re not in a position to whine about not having access to luxuries.',
        replyDepth: 1,
      },
      {
        id: 8,
        user: 'B037',
        message:
          'You’re seriously underestimating just how much my team and I do for this base, and frankly it’s insulting. There will always be a need for contact with the surface. Yes, that comes with risks. But hiding our heads in the dirt forever isn’t a solution. It’s just hiding.',
        replyDepth: 2,
      },
      {
        id: 9,
        user: 'C025',
        message:
          'It’s nothing personal, Jordan. You and your squad do great work. But we need to step back and reasonably assess whether or not expeditions are worth giving away our position.',
        replyDepth: 3,
      },
      {
        id: 10,
        user: 'B037',
        message:
          'I resent the implication that we’re just blundering around out there. Every single operation we pull off is carefully, strategically coordinated, and executed with precision and professionalism. In five years, we haven’t led anything back here and we haven’t lost a single scout. We know what we’re doing.',
        replyDepth: 4,
      },
      {
        id: 11,
        user: 'C025',
        message:
          'That’s exactly what I’m saying! It’s been a good five years, but our luck has run out. Persephone’s death was a wake up call, and I don’t get why you’re not seeing that.',
        replyDepth: 5,
      },
      {
        id: 12,
        user: 'B037',
        message:
          'It. Isn’t. Luck. That. We. Haven’t. Lost. Scouts. It. Is. Planning. expeditions. Are. Necessary. For. The. Survival. Of. This. Base.',
        replyDepth: 5,
      },
      {
        id: 13,
        user: 'D112',
        message:
          'Jordan’s team found me on an Expedition and brought me back here. I’d be dead if it weren’t for that team. I trust her judgement on this.',
        replyDepth: 2,
      },
      {
        id: 14,
        user: 'B022',
        message:
          'She’s the best leader we could hope for. I think I speak for all of the scouts when I say that she’s in the right on this one.',
        replyDepth: 3,
      },
    ],
    episode: 2,
  },
  {
    id: 210,
    title: 'So how would a lock-in work?',
    user: 'D093',
    day: 1829,
    message:
      'I don’t want to sound ignorant, but what exactly does the “lock-in” mean? Does it mean we can’t go outside ever again?',
    comments: [
      {
        id: 1,
        user: 'A003',
        message:
          'It’s a little disheartening to see that some of our residents don’t grasp the seriousness of our situation and what our solution would entail. That being said, when the lock-in occurs it means the door’s opening mechanism will be overridden, magnetically sealing the aliens and the virus out of our home. At which point, we would be surviving off of the food we currently produce in our botany lab. We are already at the self-sustainability point and I am advocating for the Council to enact the lock-in procedures as soon as possible.',
      },
      {
        id: 2,
        user: 'A007',
        message:
          'Councilor Lind, this does not seem like the best forum to disseminate this information to the facility. The Council is still in negotiations about how to proceed at this point. Please refrain from using the Discourse to push your agenda until the Council can present a unified front.',
        replyDepth: 1,
      },
    ],
    episode: 2,
  },
  {
    id: 211,
    title: 'Looking for a Cluster lesson',
    user: 'D116',
    day: 1829,
    message:
      'Okay, so embarrassingly enough I still have no idea whatsoever how to play cluster. Can someone please explain this game to me in simple and plain english?',
    comments: [
      {
        id: 1,
        user: 'D066',
        message:
          'Always great to see someone develop a luster for cluster. A general overview: cluster combines pieces and elements of every single tabletop game we’ve managed to scavenge over the past five years. It also includes a pair of roller blades, but only if you get voted to be the cluster buster by a jury of your peers. There are 231 rules in total, but which set of 231 rules each individual player follows per round depends on a few factors. You know what? This is going to take forever to write down. Come find me in the rec center sometime this afternoon if you want the basic rundown.',
      },
    ],
    episode: 2,
  },
  {
    id: 212,
    title: 'A Beautiful Service',
    user: 'D110',
    day: 1828,
    message:
      'I’d just like to thank Sister Ada for the memorial service last night. Truly touching words about a thoughtful and vibrant human being. We’ll all miss you, Persephone.',
    comments: [
      {
        id: 1,
        user: 'B012',
        message:
          'Persephone brought a lot of insight into my studies. She was always pushing herself to be able to understand the virus. Others will remember her for her kindness, but I’ll remember her for her mind. I’m going to keep pushing to fight this thing, no matter how many times A003 rejects my requests for test subjects. It’s the best way I can think of to honor her memory.',
      },
      {
        id: 2,
        user: 'D098',
        message:
          'I, for one, can’t believe that Sister Ada would politicize Persephone’s death at her own memorial like that.',
      },
      {
        id: 3,
        user: 'B013',
        message:
          'I’m sorry to hear that you feel that way, Ms. Hunter. I spoke what I felt to be true in my soul. When the Wrath of the Lamb passes by overhead, and the air is free of Pestilence, and the sky is clear of Angels, we the Elect shall emerge from the Cave and inherit all things. Persephone, in her wisdom, understood that the door to humanity’s heritage must never be sealed. If you wish to learn further about your place in the universe, Ms. Hunter, you are always welcome to join in one of our meetings or to speak to me in private regarding matters of the Faith. The Elect will always support a member of our own, especially an Unrealized member such as yourself. Peace Be With You.',
        replyDepth: 1,
      },
    ],
    episode: 2,
  },
  {
    id: 101,
    title: 'Official Facility Notice',
    user: 'A001',
    day: 1825,
    message:
      'The Council has decided by majority vote to allow one additional member to take up residence in NACS facility. Resident has undergone thorough debrief and decontamination. This facility has officially let in the last of our residents until further notice.',
    comments: [
      {
        id: 1,
        user: 'C025',
        message:
          'I bet it’s because we’re still waiting to see if we keep the doors open or closed or whatever.',
      },
      {
        id: 2,
        user: 'B080',
        message:
          'Welcome, User C117!  I bet this is all very overwhelming for you. Frankly, it’s a little overwhelming for us too! We haven’t taken in any new residents in a little over three years. You can’t be too careful about the virus, you know. Congratulations on making it through decontamination. This place is a new home in a chaotic world. Don’t worry. You’ll get used to it in no time at all.',
      },
      {
        id: 3,
        user: 'C065',
        message: 'I wonder if it’s still as crazy out there as I remember it.',
        replyDepth: 1,
      },
    ],
    episode: 1,
  },
  {
    id: 102,
    title: 'Memorial for Persephone Grace',
    user: 'A004',
    day: 1825,
    message:
      'Let us please gather in the Recreational Room for the memorial service of our dear, beloved friend, Persephone Grace.  Service will be held by Sister Ada.',
    comments: [],
    episode: 1,
  },
  {
    id: 103,
    title: 'Anyone hear?',
    user: 'D032',
    day: 1824,
    message:
      'Did anyone hear about B005?  Well I know everyone knew she was missing. But I heard she turned up dead.',
    comments: [
      {
        id: 1,
        user: 'C025',
        message:
          'Persephone.  You can say her name, y’know.  She’s a person. She was a person. And now she’s dead.',
      },
      {
        id: 2,
        user: 'D050',
        message: 'So it’s true?',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D044',
        message: 'As far as I know.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D047',
        message:
          'This is why we have our expedition protocols in place. She should’ve known better.',
      },
      {
        id: 5,
        user: 'C025',
        message:
          'Yeah. Most of us have experienced what’s out there. It’s a nightmare. Whatever the hell was going through her head that made her be so reckless… well, I hope I don’t go insane like that.  Cabin fever, maybe?',
        replyDepth: 1,
      },
      {
        id: 6,
        user: 'D021',
        message:
          'Can you guys even hear yourselves right now? One of us is dead. There’s not many of us left and she was one of us. Have some goddamn respect.',
        replyDepth: 1,
      },
    ],
    episode: 1,
  },
  {
    id: 104,
    title: 'Need Blanket',
    user: 'D061',
    day: 1823,
    message: 'Can one of the scouts pick me up a new blanket?',
    comments: [
      {
        id: 1,
        user: 'B037',
        message: 'For the last time, Doug, USE THE RESOURCE PETITION!',
      },
      {
        id: 2,
        user: 'B037',
        message: 'Also no.',
        replyDepth: 1,
      },
    ],
    episode: 1,
  },
  {
    id: 105,
    title: 'Meeting Time',
    user: 'A004',
    day: 1822,
    message:
      'As a reminder, I have open meeting time tomorrow from 1300 to 1600. If you need anyone to talk to, my door will be open.',
    comments: [
      {
        id: 1,
        user: 'C039',
        message: 'Thank you, I will be stopping by.',
      },
    ],
    episode: 1,
  },
  {
    id: 106,
    title: 'Hope to see plenty of you tomorrow!',
    user: 'b013',
    day: 1821,
    message:
      'Hello everyone! Just a reminder that the Weekly Prayer Gathering will be taking place tomorrow instead of tonight in order to avoid conflicting with the final rounds of the Cluster tournament. I’m a bit averse to all the hubbub of that game myself, so I’ll be in the chapel tonight regardless if anyone would like to stop by.',
    comments: [
      {
        id: 1,
        user: 'D078',
        message:
          'I’ll probably drop in, Sister. I have a few things weighing on my mind that I’d like to discuss if that’s alright.',
      },
      {
        id: 2,
        user: 'B013',
        message:
          'Of course, dear! There are always two open ears and one open heart in my neck of the woods.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'C039',
        message: 'See you tomorrow night, Sister.',
      },
      {
        id: 4,
        user: 'D099',
        message: 'We’ll miss you at the game!',
      },
      {
        id: 5,
        user: 'D066',
        message: 'Say a prayer for me to keep my title as reigning champ tonight!',
      },
      {
        id: 6,
        user: 'D050',
        message: 'Haha yeah, she’ll need it.',
        replyDepth: 1,
      },
      {
        id: 7,
        user: 'D066',
        message: 'Bet you won’t have the balls to say that to my face tonight.',
        replyDepth: 2,
      },
      {
        id: 8,
        user: 'B013',
        message: 'Might we mind our language just a little?',
        replyDepth: 3,
      },
      {
        id: 9,
        user: 'D066',
        message: 'Sorry, Sister!!',
        replyDepth: 4,
      },
    ],
    episode: 1,
  },
  {
    id: 107,
    title: 'Rations',
    user: 'D088',
    day: 1820,
    message:
      'Listen, I’m definitely not asking for additional rations, but if anyone is looking to get rid of any food items they don’t want…',
    comments: [
      {
        id: 1,
        user: 'C041',
        message: 'Watch yourself.',
      },
      {
        id: 2,
        user: 'D088',
        message: 'For what? I said I wasn’t asking.',
        replyDepth: 1,
      },
    ],
    episode: 1,
  },
  {
    id: 108,
    title: 'Extra Work',
    user: 'C032',
    day: 1820,
    message: 'Anyone looking to pick up some extra work?',
    comments: [
      {
        id: 1,
        user: 'D077',
        message: 'Depends on the job',
      },
      {
        id: 2,
        user: 'C032',
        message: 'Kitchen staff needs help with a deep clean.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D077',
        message: 'Nope',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D065',
        message: 'Wow, Kelly, nice attitude there. I’m in.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'D102',
        message: 'Me too',
        replyDepth: 3,
      },
      {
        id: 6,
        user: 'D056',
        message: 'I can help too if you still need it',
        replyDepth: 2,
      },
      {
        id: 7,
        user: 'C032',
        message: 'Thank you!!!',
        replyDepth: 3,
      },
    ],
    episode: 1,
  },
  {
    id: 109,
    title: 'Time to shake things up a little?',
    user: 'D078',
    day: 1820,
    message:
      'So I’ve been thinking - would anyone be interested in moving around some of the furniture in the rec room? Sometimes I feel like I’m gonna go crazy seeing the same exact stuff in the same exact configuration every single day. I think a change of scenery could do us all some good.',
    comments: [
      {
        id: 1,
        user: 'D021',
        message: 'Been talking to the shrink? That totally sounds like something he’d suggest.',
      },
      {
        id: 2,
        user: 'D078',
        message: 'I mean, yeah. It’s not a bad idea though.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D033',
        message: 'I think that’d be nice.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'B013',
        message: 'I agree! It sounds like a lovely project.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'C081',
        message: 'This sounds like something you’d probably need Council approval for.',
        replyDepth: 4,
      },
      {
        id: 6,
        user: 'D078',
        message:
          'Seriously? It’s some couches and ping pong tables, not P.A.T.R.I.C.I.A.’s mainframe.',
        replyDepth: 5,
      },
      {
        id: 7,
        user: 'C081',
        message:
          'I’m going to consult the manual on this. I think your insistence on tampering with facility layout without prior approval qualifies as antisocial behavior and you’re therefore in clear violation of Rule 14.',
        replyDepth: 5,
      },
      {
        id: 8,
        user: 'D078',
        message:
          'You’re seriously no fun. You and the Council can push the furniture back yourselves if you want. If anybody wants to help me out, let’s meet up in the rec center in an hour.',
        replyDepth: 5,
      },
    ],
    episode: 1,
  },
  {
    id: 110,
    title: 'Creatures are back',
    user: 'A003',
    day: 1819,
    message:
      'Attention residents. Heat maps have picked up additional alien activity in nearby areas. Remain calm and stay quiet for the next several hours until activity slows down.',
    comments: [
      {
        id: 1,
        user: 'A004',
        message:
          'Mathias, we should discuss this with the other three first before having the rest of the facility take any action. Please meet us in the conference room now.',
      },
      {
        id: 2,
        user: 'A004',
        message: 'Attention residents. The crisis has passed. Please resume normal activity.',
        replyDepth: 1,
      },
    ],
    episode: 1,
  },
  {
    id: 111,
    title: 'Cluster Cheater',
    user: 'D090',
    day: 1819,
    message: 'Let this be known to everyone, Todd cheats at cluster. He uses an extra set of dice.',
    comments: [
      {
        id: 1,
        user: 'D087',
        message: 'God, Kenny, you are such a sore loser.',
      },
      {
        id: 2,
        user: 'D090',
        message: 'You cheated! I should’ve won!',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D087',
        message: 'And yet you’re the cluster buster.',
        replyDepth: 2,
      },
    ],
    episode: 1,
  },
  {
    id: 112,
    title: 'reducing energy',
    user: 'B006',
    day: 1817,
    message:
      'The botany lab is going to need to pull a little extra power over the next week. If you are able to reduce your energy consumption it would be very helpful and much appreciated.',
    comments: [],
    episode: 1,
  },
  {
    id: 113,
    title: 'Can’t seem to find Persephone',
    user: 'B012',
    day: 1816,
    message:
      'Has anyone seen B005 around? I need some help in the lab and she’s not responding to any of my messages, either digital or B017-based. Sometimes I question that woman’s professionalism.',
    comments: [
      {
        id: 1,
        user: 'B017',
        message: 'I only checked the med bay so far, so there’s plenty of places she could be.',
      },
      {
        id: 2,
        user: 'B012',
        message:
          'You only checked the one place? Jeremy, it’s two in the afternoon. I asked you to track her down and pass on those reports at breakfast.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'B017',
        message: 'I got a little sidetracked.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'B012',
        message: 'By?',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'B017',
        message: 'Lunch.',
        replyDepth: 4,
      },
    ],
    episode: 1,
  },
  {
    id: 114,
    title: 'Maintenance work',
    user: 'C063',
    day: 1815,
    message:
      'Update to fellow residents - don’t be alarmed if we lose power around 1800 tomorrow. Maintenance is doing some routine work on the electrical grid. Power shouldn’t be out for longer than 30 minutes.',
    comments: [
      {
        id: 1,
        user: 'D055',
        message: 'Does it have to be at 1800? I hate eating in the dark.',
      },
      {
        id: 2,
        user: 'C063',
        message: 'Unfortunately yes. You could always eat at 1730, or wait until 1830.',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D055',
        message: 'But I eat at 1800.',
        replyDepth: 2,
      },
    ],
    episode: 1,
  },
  {
    id: 115,
    title: 'sleeping arrangements',
    user: 'D093',
    day: 1814,
    message:
      'Is anyone willing to switch bunks with me? I had a bit of a falling out with one of my bunkmates.',
    comments: [
      {
        id: 1,
        user: 'D077',
        message: 'A bit of a falling out? That’s putting it mildly you disgusting slob.',
      },
      {
        id: 2,
        user: 'D093',
        message: 'Can we not do this on the public discourse?',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D077',
        message: 'You’re the one who made this public, not me.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'D093',
        message: 'You’re unbelievable',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'D077',
        message: 'No, you are!',
        replyDepth: 4,
      },
      {
        id: 6,
        user: 'C020',
        message:
          'Take this private or I’ll have both of your privileges revoked. P.A.T.R.I.C.I.A. is watching.',
        replyDepth: 5,
      },
    ],
    episode: 1,
  },
  {
    id: 116,
    title: 'GAME?',
    user: 'D072',
    day: 1813,
    message: 'Who’s up for a game in the cantina?',
    comments: [
      {
        id: 1,
        user: 'C055',
        message: 'Not now, Sam.',
      },
      {
        id: 2,
        user: 'D112',
        message: 'Yeah, sure. I need to blow off some steam after working for A003.',
      },
      {
        id: 3,
        user: 'D072',
        message: 'Cool. I’ll bring something good to the table.',
        replyDepth: 1,
      },
    ],
    episode: 1,
  },
  {
    id: 117,
    title: 'CLUSTER',
    user: 'D072',
    day: 1811,
    message: 'Anyone looking for a game?',
    comments: [
      {
        id: 1,
        user: 'D087',
        message: 'Sure, you free in an hour?',
      },
    ],
    episode: 1,
  },
  {
    id: 118,
    title: 'A modest proposal',
    user: 'C113',
    day: 1810,
    message: 'Hey guys, do you ever wonder what would happen if we ate alien meat?',
    comments: [
      {
        id: 1,
        user: 'D073',
        message: 'What the absolute hell are you talking about?',
      },
      {
        id: 2,
        user: 'C113',
        message:
          'I mean like, do you think it would be poison to us or would it be nutritious or what?',
        replyDepth: 1,
      },
      {
        id: 3,
        user: 'D073',
        message:
          'The health benefits of the meat itself are irrelevant considering the extremely negative health benefits of being even slightly near one of those things.',
        replyDepth: 2,
      },
      {
        id: 4,
        user: 'C081',
        message:
          'I feel like this is borderline insensitive. You know, considering how it went the other way around for so many of our loved ones.',
        replyDepth: 3,
      },
      {
        id: 5,
        user: 'C113',
        message:
          'Hey, I lost people too. But it wouldn’t be a bad idea in terms of keeping us supplied. And I mean, it would kind of be poetic justice. Like, hey aliens: you eat us and we’ll eat you right back.',
        replyDepth: 4,
      },
      {
        id: 6,
        user: 'C081',
        message: 'I’m not engaging in this conversation right now.',
        replyDepth: 5,
      },
      {
        id: 7,
        user: 'B037',
        message:
          'You want to eat alien, you go out there and take one down yourself. Maybe requisition some ropes to fashion yourself a lasso.',
      },
      {
        id: 8,
        user: 'D094',
        message: 'Requisition some hot sauce for that sucker while you’re at it.',
        replyDepth: 1,
      },
      {
        id: 9,
        user: 'B037',
        message:
          'Just to be totally clear, I’m not approving any of this if actual requisition forms come my way. Although I would feed any and all of you to aliens for some hot sauce right now.',
        replyDepth: 2,
      },
      {
        id: 10,
        user: 'C068',
        message: 'The exoskeleton would get in the way, I feel like.',
        replyDepth: 3,
      },
      {
        id: 11,
        user: 'C113',
        message:
          'Very good point. Do you think it would be like, a lobster situation or more like eating a bug?',
        replyDepth: 4,
      },
      {
        id: 12,
        user: 'B017',
        message:
          'Hopefully lobster. I ate a bug once when Stevie Harrelson dared me to in first grade, and it was pretty bad. I miss that guy.',
        replyDepth: 5,
      },
      {
        id: 13,
        user: 'B037',
        message:
          'Jeremy, you know we all eat bugs right? What do you think is in those protein bars that come with your rations?',
        messageLine2: 'Hint: it’s cricket flour.',
        replyDepth: 6,
      },
      {
        id: 14,
        user: 'B017',
        message:
          'Oh. Okay, yeah, that explains the texture. This conversation is really making me crave my mom’s cooking.',
        replyDepth: 6,
      },
      {
        id: 15,
        user: 'B037',
        message: 'Me too, bud',
        replyDepth: 6,
      },
    ],
    episode: 1,
  },
]
